import React, { Suspense } from "react";
import { LoadingSpinner } from "src/components/ui/loading-spinner";

const GcpIntegration = React.lazy(() => import("./GcpIntegration"));

interface GcpIntegrationLazyProps {
  isOpen: boolean;
  onClose: () => void;
  onRefetch?: () => void;
  brandTheme?: string | null;
}

export default function GcpIntegrationLazy(props: GcpIntegrationLazyProps) {
  return (
    <Suspense fallback={<div className="flex justify-center p-4"><LoadingSpinner /></div>}>
      <GcpIntegration {...props} />
    </Suspense>
  );
}
